module.exports = __webpack_public_path__ + "static/media/cigar2.4ae113a1.jpg";